import React, { useEffect, useCallback } from 'react';
import { Disclosure } from '@headlessui/react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LogoPart from '../LogoPart';
import StudentHeaderDesktopLeftPart from './Desktop/LeftPart';
import StudentHeaderDesktopRightPart from './Desktop/RightPart';
import { WithTranslation } from 'next-i18next';
import { withTranslation } from 'next-i18next';
import * as AuthActions from '../../../../../actions/auth';
import * as MessageActions from '../../../../../actions/message';
import * as CurrentUserActions from '../../../../../actions/currentUser';
import * as FlashActions from '../../../../../actions/flash';
import appUtils from '../../../../../utils/appUtils';
import StudentHeaderMobile from './Mobile';
import MenuButton from '../MenuButton';
import { useRouter } from 'next/router';
import {
  useMessageChannel,
  MessageData,
} from '../../../../../hooks/useMessageChannel';
import {
  useBookingChannel,
  BookingData,
} from '../../../../../hooks/useBookingChannel';

function mapStateToProps(state) {
  const { unseenMessageCount } = state;
  const { count } = unseenMessageCount;
  return {
    numOfUnseenMessages: count,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators<any, any>(AuthActions, dispatch),
    userActions: bindActionCreators<any, any>(CurrentUserActions, dispatch),
    messageActions: bindActionCreators<any, any>(MessageActions, dispatch),
    flashActions: bindActionCreators<any, any>(FlashActions, dispatch),
  };
}

interface PassedProps {
  t: any;
  user: any;
  userActions: any;
  flashActions: any;
  messageActions: any;
  numOfUnseenMessages: number;
  authActions: any;
}

type Props = WithTranslation & PassedProps;

const StudentHeaderNew: React.FC<Props> = (props: Props) => {
  const {
    user,
    userActions,
    flashActions,
    messageActions,
    numOfUnseenMessages,
    authActions,
  } = props;
  const router = useRouter();
  const routerLocale = router.locale;
  const currentLocale = appUtils.getLocaleFromLang(routerLocale);

  // Handle new message notifications via Action Cable
  const handleNewMessage = useCallback(
    (data: MessageData) => {
      messageActions.receivedNewMessage(data);
    },
    [messageActions],
  );

  // Handle booking notifications via Action Cable
  const handleBooking = useCallback(
    (data: BookingData) => {
      flashActions.addMessage(data.message, {
        type: 'info',
        sticky: false,
        autoDisappear: false,
      });
    },
    [flashActions],
  );

  // Subscribe to message and booking channels
  useMessageChannel(user?.id, handleNewMessage);
  useBookingChannel(user?.id, handleBooking);

  useEffect(() => {
    userActions.getUnseenMessageCount();
  }, [userActions]);

  let ticketCount = 0;
  if (user) {
    const studentProfile = user.student_profile;
    const subTicket = studentProfile.sub_ticket;
    const ticket = studentProfile.ticket;
    ticketCount = subTicket + ticket;
  }
  return (
    <Disclosure as="nav" className="bg-white border-b border-light-gray">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <LogoPart />
                <StudentHeaderDesktopLeftPart />
              </div>
              <div className="flex items-center">
                <StudentHeaderDesktopRightPart
                  authActions={authActions}
                  userActions={userActions}
                  user={user}
                  numUnseenMessages={numOfUnseenMessages}
                  currentLocale={currentLocale}
                />
                <MenuButton open={open} />
              </div>
            </div>
          </div>
          <StudentHeaderMobile
            handleLogout={authActions.logout}
            ticketCount={ticketCount}
          />
        </>
      )}
    </Disclosure>
  );
};

const wrapped = withTranslation('common')(StudentHeaderNew);
export default connect(mapStateToProps, mapDispatchToProps)(wrapped);
